<template>
  <div class="homepage">
    <el-row>
      <el-col :span="24">
        <el-carousel class="carousel" :interval="3000" arrow="always" height="600px" width="100%;">
          <el-carousel-item v-for="item in dataimg" :key="item.index">
            <img :src="item.src" />
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>

    <div class="introduction">
      <ul class="accordion" style="margin: 0 auto;">
        <li  v-for="(item, index) in typeList" :key="item.id">
            <router-link :to="`/trend/${index + 1}`">{{ item.name }}</router-link>
        </li>
        <li class="slide-01">
          <el-row type="flex" justify-content="space-around">
            <el-col>
          <div class="img-1">
            <div class="title">【金政软件】</div>
            <div class="intro">
              &nbsp;&nbsp;金政携手众安控股打造政府绩效评价示范平台
              <span class="content-n">&nbsp;新&nbsp;</span>
              <br />
              <div class="txt">
                &nbsp;&nbsp;2018年9月10日金政携手众安控股打造政府绩效评价
                <br />&nbsp;&nbsp;示范平台项目...
              </div>
            </div>
          </div>
            </el-col>
          </el-row>
        </li>
        <li class="slide-02">
            <el-row type="flex" justify-content="space-around">
            <el-col>
          <div class="img-2">
            <router-link to="/cloud/1">
              <div class="title">【内控咨询服务】</div>
            </router-link>
            <br />
            <router-link to="/cloud/2">
              <div class="title">【IT运维服务】</div>
            </router-link>
            <br />
            <router-link to="/cloud/3">
              <div class="title">【财务增值服务】</div>
            </router-link>
          </div>
          </el-col>
          </el-row>
        </li>
          <li class="slide-03">
          <el-row type="flex" justify-content="space-around">
            <el-col>
          <div class="img-3">
            <div class="title">
              <span>【深圳市财政委员会】&nbsp;&nbsp;&nbsp;&nbsp; 【深圳市财政委员会】</span>
              <br />
              <span>【深圳市坪山人民法院】&nbsp;&nbsp; 【深圳市坪山人民法院】</span>
              <br />
              <span>【深圳市财政委员会】&nbsp;&nbsp;&nbsp;&nbsp; 【深圳市财政委员会】</span>
              <br />
              <span>【深圳市坪山人民法院】&nbsp;&nbsp; 【深圳市坪山人民法院】</span>
            </div>
          </div>
          </el-col>
          </el-row>
        </li>
        <li class="slide-04">
          <el-row type="flex" justify-content="space-around">
            <el-col>
          <div class="img-4">
            <router-link to="/about/2">
              <div class="title">
                【品牌竞争力】
                <br />【专业的培训】
                <br />【丰厚的利润】
              </div>
            </router-link>
          </div>
          </el-col>
          </el-row>
        </li>
      </ul>
        
    </div>

    <el-row>
      <el-col :span="24">
        <div class="application">
          <div class="application-title">
            <p>金政产品</p>
            <span>___</span>
          </div>
          <el-row>
            <div class="application-content">
              <el-col :span="8">
                <router-link to="/product/1">
                  <div class="img-5"></div>
                </router-link>
              </el-col>
              <el-col :span="8">
                <router-link to="/unitControl">
                  <div class="img-6"></div>
                </router-link>
              </el-col>
              <el-col :span="8">
                <router-link to="/appli">
                  <div class="img-7"></div>
                </router-link>
              </el-col>
            </div>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <div class="product">
          <div class="product-title">
            <p>解决方案</p>
            <span>___</span>
          </div>

          <el-row>
            <div class="product-content">
              <el-col :span="6">
                <div class="box-1">
                  <router-link to="case/1" name="finance">
                    <div class="img-8">
                      <span class="txt-1">财务核算一体化</span>
                    </div>
                  </router-link>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="box-1">
                  <router-link to="case/1" name="unit">
                    <div class="img-9">
                      <span class="txt-1">单位内控管理</span>
                    </div>
                  </router-link>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="box-1">
                  <router-link to="case/1" name="performance">
                    <div class="img-10">
                      <span class="txt-1">预算绩效一体化</span>
                    </div>
                  </router-link>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="box-1">
                  <router-link to="case/1" name="assets">
                    <div class="img-11">
                      <span class="txt-1">资产管理一体化</span>
                    </div>
                  </router-link>
                </div>
              </el-col>
            </div>
            </el-row>
        
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <div class="data-display">
          <div class="container">
            <div class="title">
              <p>资金内控，就选金政</p>
              <div class="txt">金政帮助客户实现精准的资金内控，合理的绩效评价。</div>
            </div>
            <div class="content">
              <el-row type="flex" justify="space-around">
                <el-col :span="8">
              <div class="item">
                <div class="sub-title">
                  <div class="img1-1"></div>
                  <span>预算编制</span>
                </div>
                <router-link to="/product-detail/3">
                  <div class="sub-content">从项目申报、项目调整到预算编审（一上一下、二上二下），预算批复进行全程的跟进管理</div>
               
                <div class="number">
                  <span class="num">
                    96
                    <span class="symbol">%</span>
                  </span>
                  <span class="txt">预算执行率</span>
                </div>
                </router-link>
                <!-- <div class="more">
                  <router-link to="/product-detail/3">了解详情 <i class="iconfont icon-r-arrow"></i></router-link>
                </div>
                <div class="line"></div> -->
              </div>
              </el-col>
              <el-col :span="8">
              <div class="item">
                <div class="sub-title">
                  <div class="img1-2"></div>
                  <span>财务收支</span>
                </div>
                <router-link to="/product-detail/7">
                  <div class="sub-content">实现指标分配与部门分解、网上报账、生成凭证、非税收入、账务处理一系列财务收支与核算操作。</div>
                
                <div class="number">
                  <span class="num">
                    35
                    <span class="symbol">%</span>
                  </span>
                  <span class="txt">财务工作效率</span>
                </div>
                </router-link>
                <!-- <div class="more">
                    <router-link to="/product-detail/7">了解详情 <i class="iconfont icon-r-arrow"></i></router-link>
                </div>-->
                <!-- <div class="line"></div> -->
              </div>
              </el-col>
              <el-col :span="8">
              <div class="item">
                <div class="sub-title">
                  <div class="img1-3"></div>
                  <span>资产管理</span>
                </div>
                <router-link to="/product-detail/11">
                <el-row>
                  <el-col>
                      <div class="sub-content">实现资产配置、录入（国标6类）、使用、折旧、盘点、处置全生命周期管理，提高资产的利用率。</div>
                  </el-col>
                </el-row>
                <div class="number">
                  <span class="num">
                    95
                    <span class="symbol">%</span>
                  </span>
                  <span class="txt">资产利用率</span>
                </div>
                </router-link>
                <!-- <div class="more">
                    <router-link to="/product-detail/11">了解详情 <i class="iconfont icon-r-arrow"></i></router-link>
                </div>-->
              </div>
              </el-col>
             </el-row>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import shouye1 from "../../assets/imgs/home/shou1.png";
import shou from "../../assets/imgs/home/shou.png";
import shou2 from "../../assets/imgs/home/shou2.png";

export default {
  name: "index",
  components: {},
  data() {
    return {
      dataimg: [
        {
          src: shouye1
        },
        {
          src: shou
        },
        {
          src: shou2
        }
      ],
      advList: [],
      trendList: [],
      caseDetail: []
    };
  },
  methods: {
    caseGo(index) {
      this.$router.push({
        name: "case-detail",
        params: {
          id: this.caseDetail[index]
        }
      });
    }
  },
  created() {},
  mounted() {
    const that = this;
    new Swiper("#certify .swiper-container", {
      watchSlidesProgress: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      loopedSlides: 5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination"
      },
      on: {
        progress: function(progress) {
          for (let i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            var slideProgress = this.slides[i].progress;
            let modify = 1;
            if (Math.abs(slideProgress) > 1) {
              modify = (Math.abs(slideProgress) - 1) * 0.8 + 1;
            }
            const translate = slideProgress * modify * 100 + "px";
            const scale = 1 - Math.abs(slideProgress) / 5;
            const zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
            slide.transform(
              "translateX(" + translate + ") scale(" + scale + ")"
            );
            slide.css("zIndex", zIndex);
            slide.css("opacity", 1);
            if (Math.abs(slideProgress) > 3) {
              slide.css("opacity", 0);
            }
          }
        },
        // // 为轮播图跳转点击事件
        // click: function() {
        //   // 这里有坑
        //   // 这里要使用 clickedIndex % 5
        //   const clickedIndex = this.clickedIndex
        //   that.caseGo(clickedIndex % 5)
        // },
        setTransition: function(transition) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            slide.transition(transition);
          }
        }
      }
    });
  }
};
</script>
